var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',[_c('a-field',{attrs:{"config":_vm.config.type},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }